import React from 'react';
import logoSvg from '../../assets/dalaride-black-gradient.svg';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  width = 40, 
  height = 17,
  onClick 
}) => {
  return (
    <img
      src={logoSvg}
      alt="Dala Rides Logo"
      width={width}
      height={height}
      className={`${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    />
  );
};

export default Logo; 